export enum AnatomyMaxPreference {    
    WillNotAcceptRightKidney = -1,
    Any = 0,
    One = 1,
    Two = 2
}